import ExpensesPage from "./expenses/ui/ExpensesPage.tsx";

export default function Expenses() {
    return <ExpensesPage />;
}
